// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"UiTreeRenderer_clickableCard__xMZij"};